class CasusUitgelicht {
	constructor(config) {
		this.config = Object.assign({
			scope: '.casus_uitgelicht',
			container: '[data-scope="container"]',
			minWidth: 823,
			maxWidth: 1100,
		}, config);

		this.scope = document.querySelectorAll(this.config.scope);
		if (this.scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.scope.forEach(section => {
			const container = section.querySelector(this.config.container);
			if (!container) return;

			window.addEventListener('scroll', () => {
				this.#updateWidth(section, container);
			}, { passive: true });

			this.#updateWidth(section, container);
		});
	}

	#updateWidth(section, container) {
		const { minWidth, maxWidth } = this.config;

		if (window.innerWidth < minWidth) {
			container.style.maxWidth = '';
			return;
		}

		const { top, bottom } = section.getBoundingClientRect();
		const viewH = window.innerHeight - 400;

		if (bottom < 0 || top > viewH) {
			container.style.maxWidth = `${minWidth}px`;
			return;
		}

		const progress = Math.min(1, Math.max(0, (viewH - top) / (viewH / 2)));
		const width = minWidth + (maxWidth - minWidth) * progress;
		container.style.maxWidth = `${width}px`;
	}
}

export default new CasusUitgelicht;
